module.exports = __webpack_public_path__ + "static/media/6.c0f0a28d.jpg";